var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPepIconLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 612",
    style: {
      enableBackground: "new 0 0 792 612"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:9.9515;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M524.5,396.3c-7.5,1.9-15.3,2.9-23.3,2.9c-35.2,0-65.9-19.6-81.7-48.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M585.1,265.9c5.9,12.2,9.1,25.8,9.1,40.3c0,19.2-5.8,37-15.7,51.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M415.1,270.4c14-33.7,47.2-57.4,86-57.4c17.9,0,34.7,5.1,48.9,13.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.4,363.8c-9.7-6.2-17.7-14.8-23.3-25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M566.7,326.1c-8.5,28.1-34.6,48.5-65.5,48.5c-6.6,0-13-0.9-19-2.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M498.2,237.8c1,0,2-0.1,3-0.1c35,0,63.8,26.2,67.9,60.1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437.7,280.9c7.1-17.9,21.6-32.1,39.7-38.9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M521.8,344.7c-6.1,3.3-13.2,5.2-20.7,5.2c-12.2,0-23.3-5.1-31.2-13.2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M534.1,278.4c6.5,7.6,10.4,17.4,10.4,28.2c0,12.7-5.4,24.1-14.1,32"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.6,275.7c7.8-7.8,18.6-12.5,30.5-12.5c9.7,0,18.7,3.2,25.9,8.6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepIconLogo);
export default __webpack_public_path__ + "static/media/pep-icon-logo.09ed69c62b1852c0fa86a6085519b28f.svg";
export { ForwardRef as ReactComponent };